import { memo } from 'react';
function StartTripIcon({ color = '#CF0000' }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14817_36762)">
        <path
          d="M13.3333 12V10H12V12H10V13.3333H12V15.3333H13.3333V13.3333H15.3333V12H13.3333Z"
          fill={color}
        />
        <path d="M13.3333 2.66699H12V8.66699H13.3333V2.66699Z" fill={color} />
        <path d="M4.00008 2.66699H2.66675V13.3337H4.00008V2.66699Z" fill={color} />
        <path d="M8.66683 2.66699H7.3335V5.33366H8.66683V2.66699Z" fill={color} />
        <path d="M8.66683 6.66699H7.3335V9.33366H8.66683V6.66699Z" fill={color} />
        <path d="M8.66683 10.667H7.3335V13.3337H8.66683V10.667Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_14817_36762">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(StartTripIcon);
